import { Injectable } from '@angular/core';
import { PageMetaLinkService } from '@spartacus/storefront';

@Injectable({
  providedIn: 'root',
})
export class CustomPageMetaLinkService extends PageMetaLinkService {
  override setCanonicalLink(url: string | undefined): void {
    let link: HTMLLinkElement = this.winRef.document.querySelector('link[rel="canonical"]') as HTMLLinkElement;

    if (!url) {
      // Removing the link is an edge case, but useful if the canonical url
      // is created in CSR while developing/testing.
      link?.remove();
      return;
    }

    if (!link) {
      link = this.renderer.createElement('link');
      link.rel = 'canonical';
      link.href = url;

      // for SEO reasons, the canonical link should be placed after the title
      const head = this.winRef.document.head;
      const title = head.querySelector('title');
      if (title) {
        this.renderer.insertBefore(head, link, title.nextSibling);
      } else {
        this.renderer.appendChild(head, link);
      }
    } else {
      link?.setAttribute('href', url);
    }
  }
}
